import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter, NavLink } from 'react-router-dom';

import Gravatar from '../users/Gravatar.jsx';

@withRouter @inject('auth') @observer
class UserAccount extends Component {
    logout = () => {
        const { auth } = this.props;
        auth.logout();
    };
    render = () => {
        const { auth } = this.props;
        if (auth && auth.isLoggedIn) {
            const userProfilePic = (<Gravatar
                email={auth.user ? auth.user.email : null}
                size={30}
                className="rounded-circle navbar-gravatar" />);
            return (
                <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                        <NavLink
                            className="nav-link dropdown-toggle"
                            activeClassName="active"
                            to="#"
                            id="navbarUserAccountDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            {userProfilePic}
                        </NavLink>
                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarUserAccountDropdown">
                            <NavLink className="dropdown-item" activeClassName="active" to="#">Account</NavLink>
                            <div className="dropdown-divider" />
                            <NavLink className="dropdown-item" onClick={this.logout} to="#">Logout</NavLink>
                        </div>
                    </li>
                </ul>
            );
        }

        return null;
    };
}


UserAccount.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
};
// UserAccount.defaultProps = {
//     auth: null,
// };

export default UserAccount;
